var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Fields to select from GET /me.
 * Explicitly selecting only what we need reduces payload size and
 * avoids triggering additional Graph permissions.
 */
const SELECTED_FIELDS = [
    "id",
    "displayName",
    "givenName",
    "surname",
    "jobTitle",
    "department",
    "companyName",
    "mail",
    "userPrincipalName",
    "mobilePhone",
    "businessPhones",
    "officeLocation",
    "streetAddress",
    "city",
    "state",
    "postalCode",
    "country",
].join(",");
/**
 * Fetches the signed-in user's profile from Microsoft Graph.
 * All fields are covered by the User.Read delegated permission.
 */
export function fetchUserProfile(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield client
            .api("/me")
            .select(SELECTED_FIELDS)
            .get();
        return user;
    });
}
